import React from 'react';
import { useLocation } from 'react-router-dom';

export function LearnHeader() {
  const location = useLocation();

  // Determine title based on current path
  const getTitle = () => {
    const path = location.pathname;
    if (path.includes('/questions-answers')) return 'Questions & Answers';
    if (path.includes('/tutorial-videos')) return 'Tutorial Videos';
    if (path.includes('/trivia')) return 'Trivia';
    return 'Learn';
  };

  return (
    <div className="learn-header">
      {/* Main Learn Title */}
      <div className="learn-title-section">
        <h1 className="learn-main-title">
          <img
            src="https://bluedrake42.nyc3.cdn.digitaloceanspaces.com/revolt-site/site-assets/logo/revolt-learn-logo-small-transparent.png"
            alt="Revolt"
            className="learn-title-logo"
          />
          {getTitle()}
        </h1>
      </div>
    </div>
  );
}